import styled from 'styled-components'
import { animated } from 'react-spring'

export const Wrapper = styled.div`
  min-height: 300px;
  position: relative;
  padding-bottom: 40px;
  box-sizing: content-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #333;
  background-position: center;
  overflow: hidden;
  > :first-child {
    position: absolute !important;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`

export const Quotes = styled.div`
  margin: 0 auto;
`

export const Quote = styled(animated.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  color: white;
  font-size: 1.4rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  text-align: center;
  z-index: 1;
  padding: 30px 20px;
  height: 100%;
  @media (max-width: 1070px) {
    align-items: flex-start;
  }
`

export const QuoteContent = styled.div`
    z-index: 1;
    min-width: 300px;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    > :first-child {
      font-weight: bold;
      line-height: 28px;
    }
    > :nth-child(2) {
      color: yellow;
      margin-top: 30px;
    }
`

export const QuoteImage = styled.div`
  width: 100%;
  margin-right: 30px;
  max-width: 400px;
  max-height: 388px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    object-fit: contain;
    border-radius: 12px;
    overflow: hidden;
  }
  @media (max-width: 1070px) {
    margin-bottom: 25px;
    margin-right: 0;
  }
`

export const Selector = styled.div`
  display: flex;
  position: absolute;
  bottom: 40px;

  > * {
    margin-right: 15px;
  }
  > :last-child {
    margin-right: 0;
  }
`

export const Dot = styled.div`
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background-color: ${(props: { selected: boolean }) => props.selected ? '#F8EE22' : '#fff'};
  cursor: pointer;
  z-index: 1;
`

export const Characters = styled.div`
  > * {
    position: absolute;
    bottom: 0;
    background-size: contain;
    background-position: center;
    height: 140px;
    width: 210px;
  }
  > :first-child {
    left: calc(50% - 220px);
    transform: translateX(-100%);
  }
  > :nth-child(2) {
    right: calc(50% - 220px);
    transform: translateX(100%);
  }
`

export const Space = styled.div`
  width: 100%;
  color: white;
  font-size: 1.4rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
  height: 100%;
  padding: 30px 20px;
  z-index: 1;
  visibility: hidden;
  opacity: 0;
  margin-top: 38px;
  @media (max-width: 1070px) {
    align-items: flex-start;
  }
`
